import { AiToolOffice } from '../ai-details/ai-tool-office';
import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckbox } from '@angular/material/checkbox';
import { DatePipe } from '@angular/common';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';


@Component({
  selector: 'app-addAIDocumentNotes',
  templateUrl: './addAIDocumentNotes.component.html',
  styleUrls: ['./addAIDocumentNotes.component.scss']
})

export class AddAIDocumentNotesComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  myCustomInfoForm!: FormGroup;

  OfficeIDList: any = [];
  myOfficeID: any;
  noteID: number = 0;
  spinner: boolean = false;



  constructor(private dialog: MatDialog,  public dialogRef: MatDialogRef<AddAIDocumentNotesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe: any) => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = AiToolOffice.resolve(oe.officeID);   // [per-office] the office the open AI tool works for
      });
    }
  }

  ngOnInit(): void {
    let group = {};
    this.myCustomInfoForm = new FormGroup(group);
    this.createFormCustomInfo();
    this.noteID = this.data.noteID;
    if(this.noteID>0){
      this.myCustomInfoForm.patchValue({
        title:  this.data.noteTitle,
        description: this.data.noteDescription
      });    
    }  
   
  }

  // Create custom info
  createFormCustomInfo(): void {
    this.myCustomInfoForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      description: ['', [Validators.required]],
    },);
  }

  close() {
    this.myCustomInfoForm.reset();
    this.dialog.closeAll();
  }


  async AddFileNote(data: any) {
    let ReqModel = {
      noteID: 0,
      noteTitle: data.title,
      note: data.description,
      fileID: this.data.documentId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.spinner = true;
    this.myCustomInfoForm.markAsPristine();
    this.coreService.addFileNote(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.myCustomInfoForm.reset();
          this.dialogRef.close("Record Added");
          this.toastr.success('Document notes added successfully.', '', {
            timeOut: 2000,
          });
        } else {
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    });
  }


  async UpdateFileNote(data: any) {
    let ReqModel = {
      noteID: Number(this.noteID),
      noteTitle: data.title,
      note: data.description,
      fileID: this.data.documentId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.spinner = true;
    this.myCustomInfoForm.markAsPristine();
    this.coreService.addFileNote(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.myCustomInfoForm.reset();
          this.dialogRef.close("Record Added");
          this.toastr.success('Document notes updated successfully.', '', {
            timeOut: 2000,
          });
        } else {
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    });
  }



   deleteFileNote() {
      var message = `Are you sure you want to remove?`;
      const title = `Confirm Remove`;
      const confirm = `Remove`;
      const dialogData = new ConfirmDialogModel(title, message, confirm);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'edituserdetails',
        maxWidth: '1000px',
        maxHeight: '500px',
        data: dialogData
      });
      dialogRef.beforeClosed().subscribe(async dialogResult => {
        if (dialogResult) {         
          var ReqModel = {
            fileID: this.data.documentId,
            noteID: Number(this.noteID),
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
            officeID: this.myOfficeID,
            officeIDList: this.OfficeIDList
          }
          this.coreService.deleteFileNote(ReqModel).subscribe(response => {
            if (response != undefined) {
              this.responseHolder = response;             
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.dialogRef.close("Record Deleted");
                this.toastr.success('Documents note remove successfully.', '', {
                  timeOut: 3000,
                });               
              }
            }
          });
        }
      });
    }

}
